import { render, staticRenderFns } from "./Opcion_Resumen.vue?vue&type=template&id=56abcfac&scoped=true&"
import script from "./Opcion_Resumen.vue?vue&type=script&lang=js&"
export * from "./Opcion_Resumen.vue?vue&type=script&lang=js&"
import style0 from "./Opcion_Resumen.vue?vue&type=style&index=0&id=56abcfac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56abcfac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCardText,VCardTitle,VDivider,VIcon})
